@let controlValue = control();

<button
  aria-label="Clear"
  mat-icon-button
  type="button"
  [disabled]="controlValue.value === null"
  (click)="$event.stopPropagation(); controlValue.reset()"
>
  <mat-icon customMatSvgIcon="pct-mdi-close-circle" />
</button>
